/* ==========================================================================
   Collection Product Grid — Tab Switching
   Color swatches on the card navigate to the linked color's product;
   no JS handler is needed.
   ========================================================================== */
(function () {
  var SECTION_SELECTOR = '.oddit-section-collection-product-grid';

  function initSection(section) {
    var tabs = section.querySelectorAll('.oddit-section-collection-product-grid__tab');
    var grids = section.querySelectorAll('.oddit-section-collection-product-grid__grid');
    var shopAllLinks = section.querySelectorAll('.oddit-section-collection-product-grid__shop-all');
    var mobileCtas = section.querySelectorAll('.oddit-section-collection-product-grid__mobile-cta');

    function toggleByTabIndex(elements, targetIndex, inactiveClass) {
      for (var i = 0; i < elements.length; i++) {
        var matches = elements[i].getAttribute('data-tab-index') === targetIndex;
        elements[i].classList.toggle(inactiveClass, !matches);
      }
    }

    section.addEventListener('click', function (e) {
      var tab = e.target.closest('.oddit-section-collection-product-grid__tab');
      if (!tab || !tabs.length) return;

      var targetIndex = tab.getAttribute('data-tab-index');

      for (var i = 0; i < tabs.length; i++) {
        var isActive = tabs[i] === tab;
        tabs[i].classList.toggle('oddit-section-collection-product-grid__tab--active', isActive);
        tabs[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }

      for (var j = 0; j < grids.length; j++) {
        var grid = grids[j];
        var matches = grid.getAttribute('data-tab-index') === targetIndex;
        grid.classList.toggle('oddit-section-collection-product-grid__grid--inactive', !matches);
        grid.classList.remove('oddit-section-collection-product-grid__grid--entering');
        if (matches) {
          // Force reflow so re-adding the class restarts the animation.
          void grid.offsetWidth;
          grid.classList.add('oddit-section-collection-product-grid__grid--entering');
        }
      }

      toggleByTabIndex(shopAllLinks, targetIndex, 'oddit-section-collection-product-grid__shop-all--inactive');
      toggleByTabIndex(mobileCtas, targetIndex, 'oddit-section-collection-product-grid__mobile-cta--inactive');
    });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
